<template>
  <!-- 余票设置 -->
  <el-dialog class="dialog-add-borrow" title="余票设置" :visible.sync="dialogVisible" width="650px">
    <el-form class="g-form-grid" ref="form" :model="form" label-width="170px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="当日余票数 :" prop="proName">
            <span>{{detailData.surplusNum}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="开放总票数 :">
            <span>{{detailData.openNum}}</span>
          </el-form-item>
        </el-col>

        <el-row :gutter="20" v-for="(item, index) in form.appointTimes" :key="index">
          <el-col :span="12">
            <el-form-item
              :label="item.startTime+'-'+item.endTime+' 余票数 :'"
              :prop="'appointTimes.'+index+'.surplusNum'"
              :rules="rules.surplusNum"
            >
              <el-input
                v-model.number="item.surplusNum"
                placeholder="请输入"
                :disabled="pageType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="item.startTime+'-'+item.endTime+' 总票数 :'">
              <span>{{item.openNum}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
export default {
  data() {
    // let validatePhoneNo = (rule, value, callback) => {
    //   if (!validate(value, 'phone')) {
    //     callback(new Error('手机号不存在'))
    //   } else {
    //     callback()
    //   }
    // }
    // let validatePass = (rule, value, callback) => {
    //   if (!validate(value, 'password')) {
    //     callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看 check 考核结果
      detailId: '', // 详情id
      dialogVisible: false,
      detailData: {},
      form: {
        appointTimes: []
      },
      rules: {
        surplusNum: [
          { required: true, message: '必填', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 detail 查看 check 考核结果
      this.detailId = detailId || ''
      this.form = { appointTimes: [] }

      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
      })

      this.dialogVisible = true
      if (this.detailId) {
        this.getDetail()
      }
    },
    // 详情
    getDetail() {
      this.$http
        .get('/AppointTicket/load', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            this.detailData = data.item

            this.form.appointTimes = data.group
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 保存
    fromSubmit(form) {
      console.log(this.form)
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .put('/AppointTicket/updateSurplusSum', {
              id: this.detailId,
              appointTimes: JSON.stringify(this.form.appointTimes)
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('余票设置成功')
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>